import React, { Component } from 'react'
import Paper from '../assets/paper.png';
import Logo from '../assets/logo.png';
import Particles from 'react-particles-js';
import '../style/Home.css'
import {
    Link
} from 'react-router-dom';
export class Home extends Component {
    render() {
        return (
            <div id="home">
                <Particles height={'100vh'} width={'100vw'} style={{ position: 'absolute', top: '0', left: '0', zIndex: '-10' }} id="particles-js"
                    params={{
                        particles: {
                            number: {
                                value: 400,
                                density: {
                                    enable: true,
                                    value_area: 1000
                                }
                            },
                            color: {
                                value: 'rgb(151, 91, 51)'
                            },
                            opacity: {
                                value: 0.5,
                                anim: {
                                    enable: true
                                }
                            },
                            size: {
                                value: 7,
                                random: true,
                                anim: {
                                    enable: true,
                                    speed: 3
                                }
                            },
                            line_linked: {
                                enable: false
                            },
                            move: {
                                speed: 0.4
                            }
                        }
                    }}
                />
                <div id="homeHeader"><span id="homeHeaderSpan">"Crypto is unstoppable. Crypto is the future."</span></div>
                <div id="homeTiles">
                    <div className="home-tile">
                        <span className="home-tile-title">What is Cardano Cookies?</span>
                        <span className="home-tile-text">Cardano Cookies is a collection of unique fortune cookies built on Cardano!</span>
                          <span className="home-tile-title">How can I get one?</span>
                           <span className="home-tile-text">Drop will be announced soon! Stay updated</span>
                    </div>
                    <Link to="/buy"> <div id="homeTileBuyBtn" className="home-tile" style={{ alignItems: 'center' }}>
                        <img id="homeTileBuyBtnLogo" src={Logo} alt="" />
                        <span>GET ADA COOKIE</span>
                    </div></Link>
                    <div className="home-tile" style={{ alignItems: 'center' }}>
                        <img src={Paper} className="home-tile-img" />
                    </div>

                </div>

            </div>
        )
    }
}

export default Home
